import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TermsConditionsDialogComponent } from '@serviceplan/ui-kit';
import { AssetsGenerateUrlService, ClientEnvironment, CoreDownloadService, ENVIRONMENT } from '@thehubz/client/core';
import { CreateAssetHistoryDto } from '@thehubz/client/data-access-api';
import { Observable, Subject, firstValueFrom, map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DownloadUploadService {
  private downloadAsset: Subject<string> = new Subject<string>();
  downloadAsset$ = this.downloadAsset.asObservable();

  constructor(
    private readonly httpClient: HttpClient,
    private readonly coreDownloadService: CoreDownloadService,
    private readonly assetUrlService: AssetsGenerateUrlService,
    @Inject(ENVIRONMENT) private readonly env: ClientEnvironment,
    private readonly matDialog: MatDialog,
  ) {}

  async downloadFile(url: string, filename: string, assetDownloadHistory?: CreateAssetHistoryDto, termsChecked?: boolean) {
    if (!url) {
      return Promise.reject('no download url given');
    }

    if (!filename) {
      return Promise.reject('no download filename given');
    }

    if (this.env.termsConditionsPopup?.onAssetDownload && !termsChecked) {
      const dialogRef = this.matDialog.open(TermsConditionsDialogComponent, {
        minHeight: '40rem',
        maxWidth: '40rem',
        data: {
          featureKey: 'assetDownload',
        },
      });

      const result = await firstValueFrom(dialogRef.afterClosed());
      if (!result.accepted) {
        return;
      }
    }

    const key = url.substring(url.search(/(workflows|assets)/));
    const signedUrl = await this.assetUrlService.getPresignedUrl(key);

    return this.coreDownloadService.downloadSignedUrl(signedUrl, filename, assetDownloadHistory);
  }

  /**
   * emit a action string
   *
   * @param action
   * @returns
   * @memberof DownloadUploadService
   */
  emitDownloadAsset(action: string) {
    this.downloadAsset.next(action);
  }

  /**
   * Used to show pdf view in blob
   * @param url
   * @param mimeType
   * @returns
   * @memberof DownloadUploadService
   */
  viewInBrowser(url: string, mimeType: string): Observable<Blob> {
    const options = { responseType: 'blob' as 'json' };
    return this.httpClient.get<Blob>(url, options).pipe(map((res) => new Blob([res], { type: mimeType })));
  }
}
